<template>
  <div style="position: relative; overflow: hidden">
    <div v-show="showMap">
      <div class="card shadow-sm card-map">
        <div class="px-2">
          <modal-menu v-if="!exibindoRota" :center="true" :menus="menus" :selected="menu" class="mt-1 mb-0" @changeMenu="toggleMenu"/>
        </div>
        <div v-if="menu === 1" class="card-map__view">
          <div class="row no-gutters px-2 mt-2" style="margin-bottom: 8px">
            <div class="col-12">
              <div class="input-group">
                <input v-model="pesquisa.id_pedido" class="form-control" inputmode="numeric" placeholder="Nº do pedido"
                       type="search" @input="filtrar()" @keyup.enter="selecionarEnter(pesquisa.id_pedido)">
                <div v-if="pesquisa.id_pedido" class="input-group-append">
                  <button class="btn btn-outline-secondary" title="Limpar busca" @click="limparFiltro()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="p-1 bg-light small text-center border-bottom">
            <div v-if="selecionados.length">Selecionados: <b style="font-variant-numeric: tabular-nums">{{selecionados.length}}</b> de <b>{{ pedidos.length }}</b> <a class="text-info ml-1" href="javascript:" @click="clearPesquisa()">(Limpar)</a></div>
            <div v-else>Selecione um pedido</div>
          </div>

          <div class="card-map__scroll p-2" @scroll="fecharSelecaoRota()">
            <div v-if="pesquisa.id_pedido && !pedidos.length" class="small text-muted text-center py-4">
              Pedido não encontrado.
            </div>
            <div v-for="p in pedidos" :key="p.id_pedido" @mouseenter="checkPin(p.coordinates, true)" @mouseleave="checkPin(p.coordinates)">
              <div :class="{'border-success': p.selected}" class="card card-map-item pointer p-2 mb-2">
                <map-pedido :p="p" :route-control="true" @selecionar="selecionar(p)" @vincularRota="selecionarRotaPedido(p, $event)"/>
              </div>
            </div>
          </div>

          <div v-if="pedidoVincular" :style="{top: posicaoMenuRota.top + 'px', left: posicaoMenuRota.left + 'px'}"
               class="rota-picker list-group shadow" @click.stop>
            <button v-for="rota in rotasVinculo" :key="rota.id_rota"
                    :disabled="vinculandoPedido" class="list-group-item list-group-item-action text-left" @click="vincularPedidoRota(rota)">
              Rota {{ rota.numero_rota }}
            </button>
            <div v-if="!rotasVinculo.length" class="small text-muted text-center py-2">Nenhuma rota em montagem.</div>
          </div>

          <div v-if="selecionados.length" class="card-map__footer p-2 border-top text-center">
            <button class="btn btn-info px-3" @click="criarRota()">
              Nova Rota <i class="fa fa-route ml-1"></i>
            </button>
          </div>
        </div>

        <div v-else class="card-map__view">
          <template v-if="exibindoRota">
            <div class="d-flex px-2 py-2 border-bottom">
              <button class="btn border" title="Voltar" @click="voltarRotas()">
                <i class="fa fa-chevron-left"></i>
              </button>
              <button v-if="rotaDetalhe && String(rotaDetalhe.status) === '1'" :disabled="$store.state.load" class="btn text-danger border ml-auto" title="Cancelar rota" @click="cancelarRota()">
                <i class="fa fa-trash-alt"></i>
              </button>
            </div>

            <div v-if="rotaDetalhe" class="card-map__scroll px-2 pb-2">
              <div class="d-flex align-items-center pt-2 pb-3">
                <div><b>{{ rotaDetalhe.id_rota ? `Rota #${rotaDetalhe.numero_rota}` : 'Nova rota' }}</b></div>
                <span :class="classeStatusRota(rotaDetalhe.status)" class="ml-auto badge">{{ rotaDetalhe.status_label }}</span>
              </div>

              <div class="form-group card">
                <button :disabled="!podeAlterarEntregadorRota" class="d-flex align-items-center w-100 text-left border-0 entregador-picker" type="button"
                        @click="modalEntregador = true">
                  <span class="entregador-picker__icon d-flex align-items-center justify-content-center mr-2">
                    <i class="fa fa-user"></i>
                  </span>
                  <span class="entregador-picker__text">
                    <b class="entregador-picker__name">{{ entregadorRotaSelecionado ? entregadorRotaSelecionado.nome : 'Selecionar entregador' }}</b>
                    <small class="d-block text-muted">
                      {{ labelStatusEntrega(rotaDetalhe.status_entrega) }}
                    </small>
                  </span>
                  <i v-if="podeAlterarEntregadorRota" class="fa fa-angle-right ml-auto"></i>
                </button>
                <div v-if="rotaDetalhe.id_logistica" class="px-2 pb-2">
                  <button class="btn btn-outline-info btn-block btn-sm" @click="abrirLogisticaRota(rotaDetalhe)">Visualizar solicitação</button>
                </div>
              </div>

              <div class="d-flex align-items-center small font-weight-bold mb-2">
                Pedidos na rota
                <span class="badge badge-light border ml-2">{{ pedidosRota.length }}</span>
              </div>

              <draggable v-model="pedidosRota" :disabled="!podeEditarRota" handle=".drag">
                <div v-for="pedido in pedidosRota" :key="pedido.id_pedido" class="card card-map-item p-2 mb-2"
                     @mouseenter="checkPin(pedido.coordinates, true)" @mouseleave="checkPin(pedido.coordinates)">
                  <map-pedido :controls="podeEditarRota" :p="pedido" @selecionar="removerPedidoRota(pedido)"/>
                </div>
              </draggable>
            </div>

            <div v-else class="card-map__scroll p-5">
              <loading text="Carregando rota.."/>
            </div>

            <div v-if="podeAlterarEntregadorRota" class="card-map__footer d-flex justify-content-center p-2 border-top">
              <button v-if="podeAlterarEntregadorRota" :disabled="salvandoEdicaoRota || !pedidosRota.length" class="btn btn-success px-3 mx-1" @click="salvarEdicaoRota()">
                {{ salvandoEdicaoRota ? 'Salvando...' : 'Salvar rota' }}
              </button>
            </div>
          </template>

          <template v-else>
            <div class="card-map__scroll px-2 pt-2">
              <div v-if="!carregandoRotas">
                <div v-for="rota in rotasOrdenadas" :key="rota.id_rota"
                     :class="{'border-primary': String(rotaExpandida) === String(rota.id_rota)}"
                     class="card card-map-item p-2 mb-2 pointer" @click="toggleRota(rota.id_rota)"
                     @mouseenter="destacarRota(rota.id_rota)" @mouseleave="restaurarDestaqueRota()">
                  <div :class="{ 'mb-2': !rota.id_entregador }" class="d-flex justify-content-between align-items-center">
                    <b>Rota #{{ rota.numero_rota }}</b>
                    <div class="d-flex align-items-center">
                      <span :class="classeStatusRota(rota.status)" class="badge">{{ rota.status_label }}</span>
                      <button class="btn btn-sm text-primary border ml-1" title="Editar rota" @click.stop="abrirRota(rota.id_rota)">
                        <i class="fa fa-pen"></i>
                      </button>
                    </div>
                  </div>
                  <div v-if="rota.id_entregador" :class="{ 'rota-entregador-bordas': rota.id_logistica }" class="d-flex align-items-center mb-2">
                    <img alt="Entregador" class="mr-2" height="24" src="@/assets/icons/moto.svg" width="24">
                    <div class="rota-entregador-texto">
                      <div class="small font-weight-bold">{{ rota.nome_entregador || 'Entregador não atribuído' }}</div>
                      <div class="small text-muted">{{ labelStatusEntrega(rota.status_entrega) }}</div>
                    </div>
                  </div>
                  <div v-if="String(rotaExpandida) === String(rota.id_rota)" @click.stop>
                    <div class="border-top mb-2">
                      <div v-for="pedido in pedidosRotaExpandida" :key="pedido.id_pedido" class="border-bottom py-2"
                           @mouseenter="checkPin(pedido.coordinates, true)" @mouseleave="checkPin(pedido.coordinates)">
                        <map-pedido :p="pedido"/>
                      </div>
                      <div v-if="!pedidosRotaExpandida.length" class="small text-muted text-center py-2">Nenhum pedido na rota.</div>
                    </div>
                  </div>
                  <div>
                    <button v-if="String(rota.status) === '1'" :disabled="processandoRota === rota.id_rota"
                            class="btn btn-info btn-block btn-sm" @click.stop="despacharRota(rota)">
                      {{ processandoRota === rota.id_rota ? 'Despachando...' : 'Despachar' }}
                    </button>
                    <button v-if="String(rota.status) === '2'" :disabled="processandoRota === rota.id_rota"
                            class="btn btn-dark btn-block btn-sm" @click.stop="finalizarRota(rota)">
                      {{ processandoRota === rota.id_rota ? 'Finalizando...' : 'Finalizar' }}
                    </button>
                  </div>
                </div>
                <div v-if="!rotas.length" class="text-center text-muted py-5">
                  Nenhuma rota encontrada.
                </div>
              </div>
              <loading v-if="carregandoRotas" text="Carregando rotas.."/>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div id="mapContainer" v-if="showMap && center">
      <l-map :zoom="zoom" :center="center" :options="mapOptions" @ready="mapReady">
        <l-tile-layer :url="url" :attribution="attribution"/>
        <l-marker :lat-lng="empresa.coordinates" v-if="empresa">
          <l-tooltip :options="{offset: [15, -2]}">
            {{empresa.nome_fantasia}}
          </l-tooltip>
          <l-icon :icon-anchor="[25, 25]" :icon-size="[50, 50]" :icon-url="require('../../assets/icons/restaurant-icon.png')" :popupAnchor="[0,-25]"/>
        </l-marker>
        <l-marker v-for="(e, index) in markers" :key="index" :icon="iconePedido(e)" :lat-lng="e.coordinates"
                  :visible="e.visible" :zIndexOffset="index + 1" @click="pinPedido(e)">
          <l-tooltip v-if="e.pedidos" :options="tooltipOption">
            <div v-for="pedido in e.itens.slice(0, 3)" :key="pedido.id_pedido" class="pedido-marker-tooltip__item">
              <div><b>#{{ pedido.id_contador }} - Previsão: {{ formatarHora(pedido.data_previsao) }}</b></div>
              <div>Cliente: {{ pedido.nome_cliente || 'Não informado' }}</div>
              <div v-if="pedido.nome_entregador">Entregador: {{ pedido.nome_entregador }}</div>
              <div class="pedido-marker-tooltip__endereco">{{ formatarEndereco(pedido) }}</div>
            </div>
            <div v-if="e.itens.length > 3" class="text-center font-weight-bold pt-1">
              +{{ e.itens.length - 3 }} pedidos
            </div>
          </l-tooltip>
        </l-marker>
        <l-marker v-for="(e, index) in geoEntregadoresMapa" :key="e.id_usuario" :lat-lng="e.coordinates" :visible="e.visible" :zIndexOffset="index + 1001">
          <l-icon :icon-anchor="[25, 25]" :icon-size="[50, 50]" :icon-url="require('../../assets/icons/moto-topview.png')" :popupAnchor="[0,-20]"/>
          <l-tooltip :options="{offset: [19, -2]}">
            <b class="mr-1">{{e.nome}}</b>
            <span class="badge badge-success" v-if="e.online">Online</span>
            <span class="badge badge-danger" v-else>Offline</span>
            <div>Atualização às {{ e.last_update }}</div>
          </l-tooltip>
        </l-marker>
      </l-map>
    </div>
    <div style="padding-top: 28vh" v-else>
      <img src="../../assets/logo-lecard.png" class="d-block m-auto animated flipInY infinite" alt="Logo Lecard" style="width: 72px;">
    </div>
    <modal-entregador :multiplos-pedidos="true" :opened="modalEntregador" :selecionado="idEntregadorModal"
                      @fechar="fecharModalEntregadorRota" @logistica="selecionarEntregadorRota" @selecionar="selecionarEntregadorRota"/>
    <modal-logistica :concluir-despacho="despacharAposLogistica" :id-logistica="rotaLogistica && rotaLogistica.id_logistica"
                     :id-rota="rotaLogistica && rotaLogistica.id_rota" :opened="modalLogistica"
                     :pedidos="pedidosLogistica" :plataforma-selecionada="plataformaLogistica"
                     @atualizar="atualizarLogisticaRota" @fechar="modalLogistica = false" @status-atualizado="atualizarStatusEntregaRota"/>
  </div>
</template>

<script>
  import { latLng, divIcon, Icon } from "leaflet";
  import { LMap, LTileLayer, LMarker, LPopup, LTooltip , LControl, LIcon, LCircle } from "vue2-leaflet";
  import draggable from "vuedraggable";
  import ModalMenu from "@/components/commons/ModalMenu";
  import MapPedido from "@/components/gestor/MapPedido";
  import Loading from "@/components/gestor/loading.vue";
  import ModalLogistica from "@/components/gestor/ModalLogistica";
  import ModalEntregador from "@/components/gestor/ModalEntregador";

  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  export default {
    name: "MapGestor",
    components: {
      ModalEntregador,
      ModalLogistica,
      Loading,
      MapPedido, ModalMenu, LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LIcon, LCircle, draggable },
    props: ['token', 'modalMapa'],

    data() {
      return {
        map: null,
        showMap: false,
        zoom: 16,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: { zoomSnap: 0.5, minZoom: 9, maxZoom: 18 },
        empresa: null,
        center: null,
        showTooltip: true,
        tooltipOption: {
          direction: 'top',
          offset: [0, -17],
          className: 'pedido-marker-label'
        },

        pin: null,
        markers: [],
        markersPedidos: [],
        pedidosMapa: [],
        pedidos: [],
        selecionados: [],
        pesquisa: {
          id_pedido: ''
        },

        timeoutEntregador: null,
        geo_entregadores: [],
        modalEntregador: false,
        modalLogistica: false,
        despacharAposLogistica: false,
        plataformaLogistica: null,
        rotaLogistica: null,
        pedidosLogistica: [],
        idRotaPendenteDespacho: null,

        menu: 1,
        carregandoRotas: false,
        rotas: [],
        carregandoRota: false,
        salvandoEdicaoRota: false,
        processandoRota: null,
        pedidoVincular: null,
        posicaoMenuRota: { top: 0, left: 0 },
        rotasVinculo: [],
        vinculandoPedido: false,
        rotaDetalhe: null,
        pedidosRota: [],
        rotaExpandida: null,
        pedidosRotaExpandida: [],
        sincronizarAoVoltar: false
      };
    },

    methods: {
      mapReady(m) {
        this.map = m;
        this.atualizarTamanhoMapa();
      },

      atualizarTamanhoMapa() {
        this.$nextTick(() => {
          if (this.map && this.modalMapa) {
            this.map.invalidateSize({ pan: false });
            this.map.setView(this.center, this.zoom, { animate: false });
          }
        });
      },

      openMapa(openCliente) {
        this.menu = 1;
        this.rotaDetalhe = null;
        this.pedidosRota = [];
        this.rotaExpandida = null;
        this.pedidosRotaExpandida = [];
        this.carregandoRota = false;
        this.sincronizarAoVoltar = false;
        this.rotas = [];
        this.pedidosMapa = [];
        this.pedidos = [];
        this.pesquisar(openCliente, () => {
          this.getEntregadores((res) => {
            if (res) this.intervalRastreamento();
          });
        });
      },

      closeMapa() {
        clearTimeout(this.timeoutEntregador);
      },

      sincronizarPedidos(silencioso = true) {
        if (!this.modalMapa) {
          return;
        }

        if (this.exibindoRota) {
          this.sincronizarAoVoltar = true;
          return;
        }

        this.pesquisar(null, null, silencioso);
      },

      pesquisar(openCliente, callback, silencioso = false) {
        this.zoom = parseInt(this.user.raio_empresa) >= 8000 ? 13 : 15;
        this.pesquisa.id_pedido = "";
        this.selecionados = [];

        if (!silencioso) {
          this.markers = [];
          this.carregandoRotas = true;
        }

        if (!this.center) {
          this.showMap = false;
          this.center = latLng(this.user.lat_empresa, this.user.long_empresa);

        } else if (!silencioso) {
          this.$store.state.load = true;
        }

        this.empresa = {
          nome_fantasia: this.user.nome_fantasia,
          lat: this.user.lat_empresa, long: this.user.long_empresa, coordinates: this.center
        };

        this.$http.get('v2/rotas/pedidos')
          .then(response => {
            const data = response.data || {};
            const id_default = (openCliente && this.selecionado) ? this.selecionado.id_pedido : null;
            this.rotaExpandida = null;
            this.pedidosRotaExpandida = [];
            this.rotas = data.rotas || [];
            this.rotasVinculo = this.rotas.filter(rota => String(rota.status) === '1' && !rota.id_logistica);
            this.pedidosMapa = (data.pedidos || []).map(item => {
              const parPreenchido = (lat, lng) => lat !== null && lat !== undefined && String(lat).trim() !== ''
                && lng !== null && lng !== undefined && String(lng).trim() !== '';
              const usarEndereco = parPreenchido(item.lat_endereco, item.long_endereco);
              const usarZona = !usarEndereco && parPreenchido(item.lat_zona, item.long_zona);
              const lat = usarEndereco ? item.lat_endereco : (usarZona ? item.lat_zona : null);
              const lng = usarEndereco ? item.long_endereco : (usarZona ? item.long_zona : null);

              return ({
              tipo_pedido: '1',
              id_pedido: item.id_pedido,
              id_contador: item.id_contador,
              status: String(item.status),
              status_entrega: item.status_entrega === null ? null : String(item.status_entrega),
              data_pedido: item.data_pedido,
              data_agendamento: item.data_agendamento,
              data_previsao: item.data_previsao,
              origin: String(item.origin),
              nome_cliente: item.nome_cliente,
              logradouro: item.logradouro,
              numero: item.numero,
              bairro: item.bairro,
              complemento: item.complemento,
              distance: item.distance,
              id_entregador: item.id_entregador || null,
              id_empresa: item.id_empresa || null,
              ordem_entrega: item.ordem_entrega || null,
              id_rota: item.id_rota || null,
              status_rota: item.status_rota || null,
              status_rota_label: item.status_rota_label || null,
              nome_entregador: item.nome_entregador || null,
              localizacao_aproximada: usarZona,
              coordinates: lat !== null ? latLng(lat, lng) : null,
              lat_endereco: lat,
              long_endereco: lng,
              selected: false
              });
            });

            this.aplicarPedidosMenu();

            const pDefault = id_default ? this.pedidos.find(p => p.id_pedido === id_default) : null;

            if (pDefault && pDefault.coordinates) {
              this.zoom = 16;
              this.center = pDefault.coordinates;
            }

            this.$nextTick(() => {
              this.$store.state.load = false;
              this.carregandoRotas = false;
              this.showMap = true;

              if (pDefault) {
                this.selecionar(pDefault);
              }
            });

            if (callback) {
              callback();
            }

          }, res => {
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
            this.$store.state.load = false;
            this.carregandoRotas = false;
          });
      },

      aplicarPedidosMenu() {
        this.selecionados = [];
        this.pedidoVincular = null;
        this.pedidosMapa.forEach(pedido => { pedido.selected = false });
        this.pedidos = this.pedidosMapa.filter(pedido => this.menu === 1 ? !pedido.id_rota : !!pedido.id_rota);
        this.montarMarkers(this.pedidos);
        this.markersPedidos = this.markers.map(marker => ({
          ...marker,
          pedidos: marker.pedidos.slice(),
          itens: marker.itens.slice()
        }));
      },

      clearPesquisa() {
        this.selecionados = [];
        this.pedidosMapa.forEach(e => { e.selected = false });
        this.limparFiltro();
      },

      limparFiltro() {
        this.pesquisa.id_pedido = '';
        this.filtrar();
      },

      filtrar() {
        const termo = String(this.pesquisa.id_pedido || '').trim();
        const aguardando = this.pedidosMapa.filter(pedido => !pedido.id_rota);
        this.pedidos = termo
          ? aguardando.filter(pedido => String(pedido.id_contador).includes(termo))
          : aguardando;
        this.montarMarkers(this.pedidos);

        if (termo) {
          this.markers.forEach(marker => { marker.highlighted = true });
        }
      },

      pinPedido(entrega) {
        if (this.menu === 2 || this.rotaDetalhe) {
          return;
        }

        entrega.pedidos.forEach(id => {
          this.selecionarEnter(id, true);
        });
      },

      selecionarEnter(id, toggle) {
        const pedido = this.pedidos.find(p => String(p.id_contador) === String(id));

        if (pedido && (!pedido.selected || toggle)) {
          this.selecionar(pedido);
        }

        this.filtrar();
      },

      mensagemPedidoComEntregador(pedido) {
        const entregador = this.entregadores.find(item => String(item.id_usuario) === String(pedido.id_entregador));
        const nome = pedido.nome_entregador || (entregador && entregador.nome) || `#${pedido.id_entregador}`;
        return `O pedido #${pedido.id_contador || pedido.id_pedido} já está vinculado ao entregador ${nome} e não pode ser adicionado a uma rota.`;
      },

      selecionar(pedido) {
        if (this.menu === 2) {
          return;
        }

        if (!pedido.selected && Number(pedido.id_entregador)) {
          this.$swal(this.mensagemPedidoComEntregador(pedido));
          return;
        }

        this.pin = null;
        pedido.selected = !pedido.selected;

        if (pedido.selected) {
          this.selecionados.push(pedido);

        } else {
          this.selecionados = this.selecionados.filter(p => p.id_pedido !== pedido.id_pedido)
        }

        this.markers.forEach(e => {
          e.visible = true;

          if (e.pedidos.includes(pedido.id_contador)) {
            e.selected = pedido.selected;
          }
        });
      },

      selecionarRotaPedido(pedido, event) {
        if (Number(pedido.id_entregador)) {
          this.$swal(this.mensagemPedidoComEntregador(pedido));
          return;
        }

        if (this.pedidoVincular && this.pedidoVincular.id_pedido === pedido.id_pedido) {
          this.fecharSelecaoRota();
          return;
        }

        const view = event.currentTarget.closest('.card-map__view');
        const viewRect = view.getBoundingClientRect();
        const buttonRect = event.currentTarget.getBoundingClientRect();
        const larguraMenu = 150;
        const alturaMenu = Math.min((this.rotasVinculo.length || 1) * 45 + 10, 180);
        let top = buttonRect.bottom - viewRect.top + 4;
        let left = buttonRect.right - viewRect.left - larguraMenu;

        if (top + alturaMenu > viewRect.height) {
          top = buttonRect.top - viewRect.top - alturaMenu - 4;
        }

        this.posicaoMenuRota = {
          top: Math.max(4, top),
          left: Math.max(4, Math.min(left, viewRect.width - larguraMenu - 4))
        };
        this.pedidoVincular = pedido;
      },

      fecharSelecaoRota() {
        this.pedidoVincular = null;
      },

      vincularPedidoRota(rota) {
        if (!this.pedidoVincular || this.vinculandoPedido) {
          return;
        }

        if (Number(this.pedidoVincular.id_entregador)) {
          this.$swal(this.mensagemPedidoComEntregador(this.pedidoVincular));
          return;
        }

        this.vinculandoPedido = true;
        const idPedido = Number(this.pedidoVincular.id_pedido);

        this.$http.post(`v2/rotas/${rota.id_rota}/pedidos`, { pedidos: [idPedido] })
          .then(() => {
            this.vinculandoPedido = false;
            this.fecharSelecaoRota();
            this.pesquisar();
          }, response => {
            this.vinculandoPedido = false;
            this.$swal(response.data && response.data.msg ? response.data.msg : 'Erro ao vincular pedido à rota');
          });
      },

      criarRota() {
        if (!this.selecionados.length) {
          this.$swal('Selecione os pedidos da rota.');
          return;
        }

        if (this.selecionados.length > 50) {
          this.$swal('Uma rota pode ter no máximo 50 pedidos');
          return;
        }

        const pedidoComEntregador = this.selecionados.find(pedido => Number(pedido.id_entregador));
        if (pedidoComEntregador) {
          this.$swal(this.mensagemPedidoComEntregador(pedidoComEntregador));
          return;
        }

        const pedidosRota = this.selecionados.slice();
        this.menu = 2;
        this.aplicarPedidosMenu();
        this.rotaDetalhe = {
          id_rota: null,
          id_entregador: null,
          id_logistica: null,
          observacao: null,
          status: '1',
          status_label: 'Em montagem',
          qtd_pedidos: pedidosRota.length
        };
        this.pedidosRota = pedidosRota.map((pedido, index) => ({
          ...pedido,
          ordem_entrega: index + 1
        }));
        this.montarMarkers(this.pedidosRota);
      },

      checkPin(coordinates, enter) {
        this.markers.forEach(marker => {
          marker.hovered = !!(enter && coordinates && marker.coordinates.equals(coordinates));
        });
      },

      iconePedido(marker) {
        const primeiroPedido = Number(marker.pedidos[0]) || '-';
        const label = marker.comRota && marker.numeroRota !== null
          ? `#${marker.numeroRota}`
          : (marker.pedidos.length > 1 ? `+${marker.pedidos.length}` : primeiroPedido);
        const classeStatus = marker.rotaDespachada
          ? 'pedido-marker__pin--rota-despachada'
          : (marker.comRota ? 'pedido-marker__pin--com-rota' : 'pedido-marker__pin--aguardando');
        const classeDestaque = marker.selected
          ? 'pedido-marker__pin--selected'
          : ((marker.hovered || marker.highlighted) ? 'pedido-marker__pin--hovered' : '');

        return divIcon({
          className: 'pedido-marker',
          html: `<div class="pedido-marker__pin ${classeStatus} ${classeDestaque}"><span>${label}</span></div>`,
          iconSize: [34, 34],
          iconAnchor: [17, 17]
        });
      },

      montarMarkers(pedidos) {
        const entregas = pedidos.filter(pedido => pedido.lat_endereco && pedido.long_endereco);
        this.markers = Object.values(entregas.reduce((acc, item) => {
          const idRota = item.id_rota || (this.rotaDetalhe && this.rotaDetalhe.id_rota) || null;
          const rota = idRota
            ? this.rotas.find(itemRota => String(itemRota.id_rota) === String(idRota))
            : null;
          const numeroRota = rota
            ? rota.numero_rota
            : (this.rotaDetalhe && this.rotaDetalhe.numero_rota) || null;
          const chave = `${item.lat_endereco},${item.long_endereco}${idRota ? `,rota:${idRota}` : ''}`;

          if (!acc[chave]) {
            acc[chave] = {
              pedidos: [],
              itens: [],
              visible: true,
              comRota: !!idRota,
              numeroRota,
              rotaDespachada: String(item.status_rota) === '2',
              selected: !!item.selected,
              hovered: false,
              highlighted: false,
              coordinates: latLng(item.lat_endereco, item.long_endereco)
            };
          }

          acc[chave].selected = acc[chave].selected || !!item.selected;
          acc[chave].rotaDespachada = acc[chave].rotaDespachada || String(item.status_rota) === '2';
          acc[chave].pedidos.push(item.id_contador);
          acc[chave].itens.push(item);
          return acc;
        }, {}));
      },

      intervalRastreamento() {
        this.timeoutEntregador = setTimeout(() => {
          this.getEntregadores();

          if (this.modalMapa) {
            this.intervalRastreamento();
          }
        }, (1000 * 60 * 4));
      },

      formatarHorarioRastreamento(data) {
        const date = this.$dayjs(data);

        if (!date.isValid()) {
          return '--:--';
        }

        return date.format('HH:mm');
      },

      normalizarRastreamento(data) {
        const latitude = Number(data?.position?.latitude);
        const longitude = Number(data?.position?.longitude);

        if (!data || !data.id_entregador || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          return null;
        }

        const entregador = this.entregadores.find(e => String(e.id_usuario) === String(data.id_entregador));
        const receivedAt = this.$dayjs(data.received_at);
        const quinzeMin = 15 * 60 * 1000;

        return {
          ...data,
          id_usuario: data.id_usuario || data.id_entregador,
          nome: entregador?.nome || `Entregador #${data.id_entregador}`,
          online: receivedAt.isValid() && this.$dayjs().diff(receivedAt) <= quinzeMin,
          last_update: this.formatarHorarioRastreamento(data.captured_at || data.received_at),
          coordinates: latLng(latitude, longitude),
          visible: this.isEntregadorVisivel(data.id_entregador)
        };
      },

      isEntregadorVisivel(idEntregador) {
        return true;
      },

      atualizarRastreamento(data) {
        const novo = this.normalizarRastreamento(data);

        if (!novo) {
          return false;
        }

        const index = this.geo_entregadores.findIndex(e => String(e.id_entregador) === String(novo.id_entregador));

        if (index >= 0) {
          const atual = this.geo_entregadores[index];
          const recebidoAtual = this.$dayjs(atual.received_at);
          const recebidoNovo = this.$dayjs(novo.received_at);

          if (recebidoAtual.isValid() && recebidoNovo.isValid() && !recebidoNovo.isAfter(recebidoAtual)) {
            return false;
          }

          this.$set(this.geo_entregadores, index, novo);
        } else {
          this.geo_entregadores.push(novo);
        }

        return true;
      },

      getEntregadores(callback) {
        this.$http.get('v2/entregador/rastreamento')
          .then((res) => {
            this.$store.state.load = false;
            this.geo_entregadores = (Array.isArray(res.data) ? res.data : [])
              .map(e => this.normalizarRastreamento(e))
              .filter(Boolean);

            if (callback) {
              callback(!!this.geo_entregadores.length);
            }

          }, res => {
            if (callback) {
              callback(false);
            }
            this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
          });
      },

      setRastreamento(data) {
        if (!this.modalMapa) {
          return;
        }

        this.atualizarRastreamento(data);
      },

      toggleMenu(m) {
        this.menu = m;
        this.pesquisa.id_pedido = '';
        this.rotaExpandida = null;
        this.pedidosRotaExpandida = [];
        this.rotaDetalhe = null;
        this.pedidosRota = [];
        this.aplicarPedidosMenu();
      },

      detalhesRotaLocal(idRota) {
        const rota = this.rotas.find(item => String(item.id_rota) === String(idRota));

        if (!rota) {
          return null;
        }

        const pedidos = this.pedidosMapa
          .filter(pedido => String(pedido.id_rota) === String(idRota))
          .slice()
          .sort((a, b) => Number(a.ordem_entrega) - Number(b.ordem_entrega))
          .map(pedido => ({...pedido}));

        return {
          rota: {...rota, qtd_pedidos: pedidos.length},
          pedidos
        };
      },

      restaurarMarkersRotas() {
        this.markers = this.markersPedidos.map(marker => ({
          ...marker,
          pedidos: marker.pedidos.slice(),
          itens: marker.itens.slice()
        }));
      },

      exibirRotaExpandida(detalhes) {
        this.pedidosRotaExpandida = detalhes.pedidos.map(pedido => ({...pedido}));
        this.montarMarkers(this.pedidosRotaExpandida);
      },

      destacarRota(idRota) {
        const detalhes = this.detalhesRotaLocal(idRota);

        if (detalhes) {
          this.montarMarkers(detalhes.pedidos);
        }
      },

      restaurarDestaqueRota() {
        const detalhes = this.rotaExpandida ? this.detalhesRotaLocal(this.rotaExpandida) : null;

        if (detalhes) {
          this.montarMarkers(detalhes.pedidos);
        } else {
          this.restaurarMarkersRotas();
        }
      },

      toggleRota(idRota) {
        if (String(this.rotaExpandida) === String(idRota)) {
          this.rotaExpandida = null;
          this.pedidosRotaExpandida = [];
          this.restaurarMarkersRotas();
          return;
        }

        const detalhes = this.detalhesRotaLocal(idRota);

        if (!detalhes) {
          return;
        }

        this.rotaExpandida = idRota;
        this.exibirRotaExpandida(detalhes);
      },

      abrirRota(idRota) {
        const detalhes = this.detalhesRotaLocal(idRota);

        if (!detalhes) {
          this.$swal('Rota não encontrada');
          return;
        }

        this.rotaExpandida = null;
        this.pedidosRotaExpandida = [];
        this.rotaDetalhe = {...detalhes.rota};
        this.pedidosRota = detalhes.pedidos.map(pedido => ({...pedido}));
        this.montarMarkers(this.pedidosRota);
      },

      voltarRotas() {
        this.carregandoRota = false;
        this.rotaDetalhe = null;
        this.pedidosRota = [];
        this.pin = null;
        this.restaurarMarkersRotas();

        if (this.sincronizarAoVoltar) {
          this.sincronizarAoVoltar = false;
          this.pesquisar();
        }
      },

      removerPedidoRota(pedido) {
        if (!this.podeEditarRota) {
          return;
        }

        this.pedidosRota = this.pedidosRota.filter(item => item.id_pedido !== pedido.id_pedido);
        this.montarMarkers(this.pedidosRota);
      },

      abrirLogisticaRota(rota, despachar = false) {
        const detalhes = this.detalhesRotaLocal(rota.id_rota);
        this.rotaLogistica = rota;
        this.despacharAposLogistica = despachar;
        this.pedidosLogistica = detalhes ? detalhes.pedidos : this.pedidosRota;
        this.plataformaLogistica = this.entregadores.find(e => String(e.id_usuario) === String(rota.id_entregador)) || null;
        this.modalEntregador = false;
        this.modalLogistica = true;
      },

      receberStatusRota(data) {
        if (!this.modalMapa || !data || !Number.isInteger(Number(data.id_rota)) || Number(data.id_rota) <= 0) return;
        const idRota = String(data.id_rota);
        const status = Number(data.status);
        if (![1, 2, 3, 4].includes(status)) return;
        const rotas = [this.rotaDetalhe, this.rotaLogistica, ...this.rotas].filter(rota => rota && String(rota.id_rota) === idRota);
        if (!rotas.length) return;
        const cancelamento = status === 4 || (data.status_entrega === null && data.id_logistica === null && data.id_entregador === null);

        if (cancelamento) {
          if (this.rotaDetalhe && String(this.rotaDetalhe.id_rota) === idRota) {
            this.rotaDetalhe = null;
            this.pedidosRota = [];
          }
          if (this.rotaLogistica && String(this.rotaLogistica.id_rota) === idRota) this.modalLogistica = false;
          this.pesquisar(null, null, true);
          return;
        }

        const labels = { 1: 'Em montagem', 2: 'Despachada', 3: 'Finalizada', 4: 'Cancelada' };
        rotas.forEach(rota => {
          this.$set(rota, 'status', String(status));
          this.$set(rota, 'status_label', labels[status]);
        });
        this.atualizarStatusEntregaRota(data);

        if (status === 3) {
          this.atualizarStatusRotaLocal(idRota, status);
          if (this.rotaDetalhe && String(this.rotaDetalhe.id_rota) === idRota) this.voltarRotas();
          if (this.rotaLogistica && String(this.rotaLogistica.id_rota) === idRota) this.modalLogistica = false;
        }

        this.rotasVinculo = this.rotas.filter(rota => String(rota.status) === '1' && !rota.id_logistica);
        this.aplicarPedidosMenu();
        if (!this.rotaDetalhe) this.restaurarMarkersRotas();
      },

      atualizarStatusEntregaRota({ id_rota, status_entrega }) {
        if (!id_rota || status_entrega === undefined) return;
        [this.rotaDetalhe, this.rotaLogistica, ...this.rotas].filter(item => item && String(item.id_rota) === String(id_rota)).forEach(item => {
          this.$set(item, 'status_entrega', status_entrega);
        });
      },

      atualizarLogisticaRota({ ids_pedidos, entregador, id_logistica, status_logistica, status_entrega, rota_despachada }) {
        this.$emit('atualizar-logistica', { ids_pedidos, entregador, despachar: false });
        const rota = this.rotaLogistica;
        if (!rota) return;
        this.$set(rota, 'id_logistica', entregador ? id_logistica : null);
        this.$set(rota, 'status_logistica', entregador ? status_logistica : null);
        rota.id_entregador = entregador ? entregador.id_usuario : null;
        rota.nome_entregador = entregador ? entregador.nome : null;
        const idRota = rota.id_rota;
        [this.rotaDetalhe, ...this.rotas].filter(item => item && String(item.id_rota) === String(idRota)).forEach(item => {
          this.$set(item, 'id_logistica', rota.id_logistica);
          this.$set(item, 'status_logistica', rota.status_logistica);
          item.id_entregador = rota.id_entregador;
          item.nome_entregador = rota.nome_entregador;
        });
        this.pedidosMapa.filter(p => ids_pedidos.map(Number).includes(Number(p.id_pedido))).forEach(p => {
          p.id_entregador = rota.id_entregador;
          p.nome_entregador = rota.nome_entregador;
          if (!entregador) p.status_entrega = null;
        });
        this.atualizarStatusEntregaRota({ id_rota: idRota, status_entrega });
        if (rota_despachada) {
          this.modalLogistica = false;
          this.rotaDetalhe = null;
          this.pedidosRota = [];
          this.atualizarStatusRotaLocal(idRota, 2);
        }
      },

      selecionarEntregadorRota(entregador) {
        if (this.idRotaPendenteDespacho && !entregador) {
          this.$swal('Selecione um entregador para despachar a rota');
          return;
        }

        if (this.idRotaPendenteDespacho && entregador && Number(entregador.id_auth)) {
          const detalhes = this.detalhesRotaLocal(this.idRotaPendenteDespacho);
          if (!detalhes) return;
          const rota = { ...detalhes.rota, id_entregador: entregador.id_usuario, nome_entregador: entregador.nome };
          this.idRotaPendenteDespacho = null;
          this.abrirLogisticaRota(rota, true);
          return;
        }

        if (this.idRotaPendenteDespacho) {
          this.despacharRotaComEntregador(entregador);
          return;
        }

        if (!this.rotaDetalhe) return;
        if (String(this.rotaDetalhe.status) === '2' && entregador && Number(entregador.id_auth)) {
          this.$swal('Selecione a logística externa antes de despachar a rota');
          return;
        }

        this.$set(this.rotaDetalhe, 'status_entrega', entregador && !Number(entregador.id_auth) ? 'aguardando_entrega' : null);
        this.rotaDetalhe.id_entregador = entregador ? entregador.id_usuario : null;
        this.rotaDetalhe.nome_entregador = entregador ? entregador.nome : null;
        this.modalEntregador = false;
      },

      montarDadosRota(rota, pedidos) {
        const dados = {
          id_entregador: rota.id_entregador ? Number(rota.id_entregador) : null
        };

        if (String(rota.status) !== '2') {
          dados.observacao = rota.observacao || null;
          dados.pedidos = pedidos.map((pedido, index) => ({
            id_pedido: Number(pedido.id_pedido),
            ordem: index + 1
          }));
        }

        if (rota.id_rota) dados.id_rota = Number(rota.id_rota);
        return dados;
      },

      persistirRota(rota, pedidos) {
        return this.$http.post('v2/rotas', this.montarDadosRota(rota, pedidos));
      },

      despacharRotaComEntregador(entregador) {
        const idRota = this.idRotaPendenteDespacho;
        this.modalEntregador = false;
        this.idRotaPendenteDespacho = null;
        this.executarStatusRota(idRota, 2, null, entregador);
      },

      fecharModalEntregadorRota() {
        this.modalEntregador = false;
        this.idRotaPendenteDespacho = null;
      },

      salvarEdicaoRota() {
        if (!this.pedidosRota.length) {
          this.$swal('Informe ao menos um pedido');
          return;
        }

        const rotaExistente = !!this.rotaDetalhe.id_rota;
        this.salvandoEdicaoRota = true;

        this.persistirRota(this.rotaDetalhe, this.pedidosRota)
          .then(response => {
            this.salvandoEdicaoRota = false;
            this.rotaDetalhe.id_rota = this.rotaDetalhe.id_rota || response.data.id_rota;
            this.rotaDetalhe.numero_rota = this.rotaDetalhe.numero_rota || response.data.numero_rota;
            this.pedidosRota = this.pedidosRota.map((pedido, index) => ({
              ...pedido,
              ordem_entrega: index + 1
            }));
            this.rotaDetalhe.qtd_pedidos = this.pedidosRota.length;
            const entregador = this.entregadores.find(item => String(item.id_usuario) === String(this.rotaDetalhe.id_entregador));
            this.rotaDetalhe.nome_entregador = entregador ? entregador.nome : null;
            this.sincronizarRotaLocal();
            const rotaSalva = { ...this.rotaDetalhe };
            this.voltarRotas();
            if (entregador && Number(entregador.id_auth)) this.abrirLogisticaRota(rotaSalva);


            if (!rotaExistente) {
              const possuiPedidosAguardando = this.pedidosMapa.some(pedido => !pedido.id_rota);
              this.menu = possuiPedidosAguardando ? 1 : 2;
              this.aplicarPedidosMenu();
            }
          }, response => {
            this.salvandoEdicaoRota = false;
            this.$swal(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar rota');
          });
      },

      sincronizarRotaLocal() {
        const idRota = Number(this.rotaDetalhe.id_rota);
        const pedidosRota = new Map(this.pedidosRota.map((pedido, index) => [Number(pedido.id_pedido), index + 1]));

        this.pedidosMapa.forEach(pedido => {
          const ordem = pedidosRota.get(Number(pedido.id_pedido));

          if (ordem) {
            pedido.id_rota = idRota;
            pedido.status_rota = Number(this.rotaDetalhe.status);
            pedido.status_rota_label = this.rotaDetalhe.status_label;
            pedido.ordem_entrega = ordem;

          } else if (Number(pedido.id_rota) === idRota) {
            pedido.id_rota = null;
            pedido.status_rota = null;
            pedido.status_rota_label = null;
            pedido.ordem_entrega = null;
          }
        });

        this.pedidosRota.forEach((pedido, index) => {
          pedido.id_rota = idRota;
          pedido.status_rota = Number(this.rotaDetalhe.status);
          pedido.status_rota_label = this.rotaDetalhe.status_label;
          pedido.ordem_entrega = index + 1;
        });

        const rota = {
          ...this.rotaDetalhe,
          id_rota: String(idRota),
          id_entregador: this.rotaDetalhe.id_entregador || null,
          nome_entregador: this.rotaDetalhe.nome_entregador || null,
          status: String(this.rotaDetalhe.status),
          status_label: this.rotaDetalhe.status_label
        };
        const indexRota = this.rotas.findIndex(item => Number(item.id_rota) === idRota);

        if (indexRota >= 0) {
          this.$set(this.rotas, indexRota, {...this.rotas[indexRota], ...rota});
        } else {
          this.rotas.unshift(rota);
        }

        this.rotasVinculo = this.rotas.filter(item => String(item.status) === '1' && !item.id_logistica);
        this.aplicarPedidosMenu();
        this.montarMarkers(this.pedidosRota);
      },

      cancelarRota() {
        const idRota = this.rotaDetalhe && this.rotaDetalhe.id_rota;

        if (!idRota) {
          this.$swal({
            text: 'Deseja descartar esta rota?',
            buttons: ['Não', 'Sim'],
            dangerMode: true
          }).then(confirmado => {
            if (confirmado) {
              this.voltarRotas();
            }
          });
          return;
        }

        this.alterarStatusRota(this.rotaDetalhe, 4);
      },

      despacharRota(rota) {
        if (!rota.id_entregador) {
          this.idRotaPendenteDespacho = rota.id_rota;
          this.modalEntregador = true;
          return;
        }

        this.alterarStatusRota(rota, 2);
      },

      finalizarRota(rota) {
        this.alterarStatusRota(rota, 3);
      },

      alterarStatusRota(rota, status) {
        const acoes = {
          2: { verbo: 'despachar', gerundio: 'despachar' },
          3: { verbo: 'finalizar', gerundio: 'finalizar' },
          4: { verbo: 'cancelar', gerundio: 'cancelar' }
        };
        const acao = acoes[status];

        if (!acao) {
          return;
        }

        this.$swal({
          text: `Deseja ${acao.verbo} a rota #${rota.numero_rota}?`,
          buttons: ['Não', 'Sim'],
          dangerMode: status === 4
        }).then(confirmado => {
          if (!confirmado) {
            return;
          }

          this.executarStatusRota(rota.id_rota, status, acao);
        });
      },

      executarStatusRota(idRota, status, acao, entregador) {
        if (Number(status) === 2 && !entregador) {
          let rota = this.rotas.find(item => String(item.id_rota) === String(idRota));

          if (this.rotaDetalhe && String(this.rotaDetalhe.id_rota) === String(idRota)) {
            rota = this.rotaDetalhe;
          }

          if (rota && !rota.id_entregador) {
            this.idRotaPendenteDespacho = idRota;
            this.modalEntregador = true;
            return;
          }
        }

        const dadosAcao = acao || { gerundio: status === 2 ? 'despachar' : (status === 3 ? 'finalizar' : 'cancelar') };
        const cancelando = Number(status) === 4;

        if (cancelando) {
          this.$store.state.load = 'Cancelando rota..';
        } else {
          this.processandoRota = idRota;
        }

        const dados = { id_rota: Number(idRota), status };
        if (entregador) dados.id_entregador = Number(entregador.id_usuario);

        this.$http.post('v2/rotas/status', dados)
          .then(response => {
            this.modalLogistica = false;
            if (cancelando) this.$store.state.load = false;
            else this.processandoRota = null;
            this.rotaDetalhe = null;
            this.pedidosRota = [];

            if (entregador) {
              const rota = this.rotas.find(item => String(item.id_rota) === String(idRota));
              if (rota) {
                rota.id_entregador = entregador.id_usuario;
                rota.nome_entregador = entregador.nome;
              }
            }

            if ([2, 3].includes(Number(status))) {
              this.atualizarStatusRotaLocal(idRota, status);
              this.atualizarStatusEntregaRota(response.data || {});
            } else {
              this.pesquisar();
            }
          }, response => {
            if (cancelando) this.$store.state.load = false;
            else this.processandoRota = null;
            if (Number(status) === 2 && response.data && response.data.code === 'ROUTE_LOGISTICS_PENDING') {
              const rota = this.rotas.find(item => String(item.id_rota) === String(idRota));
              if (rota) this.abrirLogisticaRota(rota, true);
              return;
            }
            this.$swal(response.data && response.data.msg ? response.data.msg : `Erro ao ${dadosAcao.gerundio} rota`);
          });
      },

      atualizarStatusRotaLocal(idRota, status) {
        const statusRota = String(status);
        const labels = {
          '2': 'Despachada',
          '3': 'Finalizada'
        };
        const indexRota = this.rotas.findIndex(rota => String(rota.id_rota) === String(idRota));

        if (statusRota === '3') {
          this.rotas = this.rotas.filter(rota => String(rota.id_rota) !== String(idRota));
          this.pedidosMapa = this.pedidosMapa.filter(pedido => String(pedido.id_rota) !== String(idRota));

        } else if (indexRota >= 0) {
          this.$set(this.rotas, indexRota, {
            ...this.rotas[indexRota],
            status: statusRota,
            status_label: labels[statusRota]
          });
        }

        if (statusRota !== '3') {
          this.pedidosMapa.forEach(pedido => {
            if (String(pedido.id_rota) === String(idRota)) {
              pedido.status_rota = statusRota;
              pedido.status_rota_label = labels[statusRota];
            }
          });
        }

        this.rotaExpandida = null;
        this.pedidosRotaExpandida = [];
        this.rotasVinculo = this.rotas.filter(rota => String(rota.status) === '1' && !rota.id_logistica);
        this.aplicarPedidosMenu();
      },

      formatarData(data) {
        const date = this.$dayjs(data);
        return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : '-';
      },

      formatarHora(data) {
        const date = this.$dayjs(data);
        return date.isValid() ? date.format('HH:mm') : '-';
      },

      formatarEndereco(pedido) {
        return [pedido.logradouro, pedido.numero, pedido.bairro].filter(Boolean).join(', ') || 'Endereço não informado';
      },

      labelStatusEntrega(status) {
        return {
          aguardando_pagamento: 'Aguardando pagamento',
          aguardando_entregador: 'Aguardando entregador',
          aguardando_entrega: 'Aguardando coleta',
          em_rota: 'Em rota de entrega',
          entregue: 'Entregue'
        }[status] || 'Aguardando vínculo';
      },

      classeStatusRota(status) {
        const classes = {
          '1': 'badge-blue',
          '2': 'badge-dark',
          '3': 'badge-success',
          '4': 'badge-secondary'
        };
        return classes[String(status)] || 'badge-light';
      },
    },

    mounted() {
      document.addEventListener('click', this.fecharSelecaoRota);
    },

    watch: {
      modalMapa(aberto) {
        if (aberto) {
          this.atualizarTamanhoMapa();
        } else {
          this.modalLogistica = false;
          this.modalEntregador = false;
          this.idRotaPendenteDespacho = null;
        }
      }
    },

    sockets: {
      connect() {
        if (this.modalMapa) this.sincronizarPedidos(true);
      },

      delivery_status(data) {
        if (this.modalMapa) this.receberStatusRota(data);
      }
    },

    beforeDestroy() {
      document.removeEventListener('click', this.fecharSelecaoRota);
      this.closeMapa();
    },

    computed: {
      pedidosEntregador() {
        if (!this.idRotaPendenteDespacho) return this.pedidosRota;
        return this.pedidosMapa
          .filter(pedido => String(pedido.id_rota) === String(this.idRotaPendenteDespacho))
          .slice().sort((a, b) => Number(a.ordem_entrega) - Number(b.ordem_entrega));
      },
      menus() {
        const aguardando = this.pedidosMapa.filter(pedido => !pedido.id_rota).length;
        const qtdRotas = this.rotas.length;

        return [
          { nome: `Aguardando (${aguardando})`, active: true },
          { nome: `Rotas (${qtdRotas})`, active: true }
        ];
      },

      user() {
        return this.$store.state.dataUser
      },

      entregadores() {
        return this.user.entregadores || [];
      },

      entregadorRotaSelecionado() {
        if (!this.rotaDetalhe || !this.rotaDetalhe.id_entregador) return null;
        return this.entregadores.find(entregador =>
          String(entregador.id_usuario) === String(this.rotaDetalhe.id_entregador)
        ) || null;
      },

      idEntregadorModal() {
        if (this.rotaDetalhe) return this.rotaDetalhe.id_entregador;
        if (!this.idRotaPendenteDespacho) return null;
        const rota = this.rotas.find(item => String(item.id_rota) === String(this.idRotaPendenteDespacho));
        return rota ? rota.id_entregador : null;
      },

      podeEditarRota() {
        return this.rotaDetalhe && String(this.rotaDetalhe.status) === '1' && !this.rotaDetalhe.id_logistica;
      },

      podeAlterarEntregadorRota() {
        return this.rotaDetalhe && ['1', '2'].includes(String(this.rotaDetalhe.status)) && !this.rotaDetalhe.id_logistica;
      },

      exibindoRota() {
        return this.menu === 2 && !!(this.rotaDetalhe || this.carregandoRota);
      },

      rotasOrdenadas() {
        return this.rotas.slice().sort((a, b) => Number(a.status) - Number(b.status));
      },

      geoEntregadoresMapa() {
        const idRota = this.rotaExpandida || (this.rotaDetalhe && this.rotaDetalhe.id_rota);
        const rota = this.rotas.find(item => String(item.id_rota) === String(idRota));

        if (!rota || !rota.id_entregador) {
          return this.geo_entregadores;
        }

        return this.geo_entregadores.filter(entregador => String(entregador.id_usuario) === String(rota.id_entregador));
      }
    }
  };
</script>
<style>
  .rota-entregador-bordas {
    border-top: 1px solid #dee2e6;
    margin-top: .5rem;
    margin-bottom: .5rem;
    padding-top: .5rem;
    padding-bottom: .2rem;
  }
  #mapContainer {
    height: calc(100vh - 76px);
  }

  .card-map {
    position: absolute!important;
    z-index: 10000;
    right: 15px;
    top: 10px;
    bottom: 10px;
    width: 370px;
    overflow: hidden;
  }

  .card-map__view {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  .card-map__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .card-map__footer {
    flex-shrink: 0;
  }

  .entregador-picker {
    min-height: 58px;
    padding: .5rem .65rem;
    color: #3a3b45;
    background: transparent;
  }

  .entregador-picker:not(:disabled):hover {
    border-color: #858796;
    background: transparent;
  }

  .entregador-picker:disabled {
    cursor: default;
    background: transparent;
  }

  .entregador-picker__icon {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    color: #4e73df;
    border-radius: 50%;
    background: #f1f3f9;
  }

  .entregador-picker__text {
    min-width: 0;
  }

  .entregador-picker__text,
  .rota-entregador-texto {
    line-height: 1.1;
  }

  .entregador-picker__name {
    display: block;
    font-size: .875rem;
  }

  .rota-picker {
    position: absolute;
    z-index: 10;
    width: 150px;
    max-height: 180px;
    padding: .5rem 0;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: #fff;
  }

  .rota-picker .list-group-item {
    padding: .35rem .5rem;
    border: 0;
  }

  .card-map-item {
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  .card-map-item:hover {
    box-shadow: 0 .125rem .25rem 0 rgba(58, 59, 69, .2) !important
  }

  .card-map-item.border-success,
  .card-map-item.border-primary {
    border-width: 2px !important;
  }

  .badge-blue {
    background-color: #237cff;
    color: #fff;
  }

  .pedido-marker-label {
    min-width: 210px;
    width: 240px;
    max-width: calc(100vw - 32px);
    padding: 2px 5px;
    border: 0;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 400;
    line-height: 1;
    white-space: normal;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .25);
  }

  .pedido-marker-tooltip__item {
    padding: 5px 3px;
    line-height: 1.3;
  }

  .pedido-marker-tooltip__item + .pedido-marker-tooltip__item {
    border-top: 1px solid #dee2e6;
  }

  .pedido-marker-tooltip__endereco {
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .pedido-marker {
    background: transparent;
    border: 0;
  }

  .pedido-marker__pin {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: #f6c23e;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .3);
    transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  }

  .pedido-marker__pin--aguardando {
    background: #f6c23e;
    color: #212529;
  }

  .pedido-marker__pin--com-rota {
    background: #2F7CFF;
    color: #fff;
  }

  .pedido-marker__pin--rota-despachada {
    background: #343a40;
    color: #fff;
  }

  .pedido-marker__pin--selected {
    background: #1cc88a;
  }

  .pedido-marker__pin--hovered {
    border-color: #fff;
    transform: scale(1.15);
    box-shadow: 0 0 0 3px rgba(35, 124, 255, .55), 0 4px 10px rgba(0, 0, 0, .35);
  }

</style>
